var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { sm: "12", md: "6" } },
        [
          _c(
            "w-card",
            [
              _c(
                "w-card-title",
                [
                  _c("div", [_vm._v(_vm._s(_vm.mainAddressTitle))]),
                  _c("w-spacer"),
                  _c(
                    "div",
                    { style: { display: "flex", flexDirection: "row" } },
                    [
                      _c("w-switch", {
                        style: { fontSize: "12px" },
                        attrs: {
                          disabled: _vm.hasInvoicesThatWereSentOverPeppol,
                          value: _vm.contact.Vat === null,
                          label: "Particulier",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.setContactVatNull($event)
                          },
                        },
                      }),
                      _vm.hasInvoicesThatWereSentOverPeppol
                        ? _c(
                            "w-link",
                            {
                              staticClass: "ml",
                              on: {
                                click: function ($event) {
                                  return _vm.showIsParticulierCannotBechangedBecauseOfExistingInvoicesDialog()
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "info" } })],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-card-content",
                [
                  _c("app-address", {
                    attrs: {
                      "group-id": _vm.contact.GroupID,
                      "contact-address": _vm.contact.MainAddress,
                      "is-particulier": _vm.contact.Vat === null,
                      "hide-label": "",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { sm: "12", md: "6" } },
        [
          _c(
            "w-card",
            [
              _c(
                "w-card-title",
                [
                  _vm._v(" " + _vm._s(_vm.$ct("titles.settings")) + " "),
                  _vm.checkVat
                    ? _c("w-progress-linear", {
                        staticClass: "full inTitle",
                        attrs: { color: "#1c86f0" },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "w-card-content",
                [
                  _vm.contact.Vat !== null
                    ? _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            { attrs: { md: "6", sm: "12" } },
                            [
                              _c(
                                "w-row",
                                { attrs: { "no-margin": "", center: "" } },
                                [
                                  _c("w-input", {
                                    style: { flexGrow: 1, marginRight: "5px" },
                                    attrs: {
                                      disabled:
                                        _vm.hasInvoicesThatWereSentOverPeppol,
                                      label: _vm.$ct("labels.Vat"),
                                      fancy: "",
                                      "icon-tooltip":
                                        _vm.$ct("tooltip.check-vat"),
                                      icon: "search",
                                    },
                                    on: {
                                      blur: function ($event) {
                                        return _vm.onVatBlur()
                                      },
                                      keyup: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        )
                                          return null
                                        return _vm.checkVatSearch()
                                      },
                                      "icon-click": function ($event) {
                                        return _vm.onVatCheck()
                                      },
                                    },
                                    model: {
                                      value: _vm.contact.Vat,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.contact, "Vat", $$v)
                                      },
                                      expression: "contact.Vat",
                                    },
                                  }),
                                  _vm.hasInvoicesThatWereSentOverPeppol
                                    ? _c(
                                        "w-button",
                                        {
                                          attrs: { round: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.showVatCannotBeChangedBecauseOfExistingInvoicesModal()
                                            },
                                          },
                                        },
                                        [
                                          _c("w-fa", {
                                            attrs: { icon: "info" },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { md: "6", sm: "12" } },
                            [
                              _c("w-input", {
                                attrs: {
                                  label: _vm.$ct("labels.Commercial"),
                                  fancy: "",
                                },
                                on: { blur: _vm.checkPeppol },
                                model: {
                                  value: _vm.contact.CommercialVat,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.contact, "CommercialVat", $$v)
                                  },
                                  expression: "contact.CommercialVat",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { sm: "12" } },
                            [
                              _c("app-peppol-registration-status", {
                                ref: "peppolstatus",
                                attrs: { contact: _vm.contact },
                              }),
                            ],
                            1
                          ),
                          _vm.showPeppolEndpointEdit
                            ? _c(
                                "w-col",
                                { attrs: { sm: "12" } },
                                [
                                  _c("app-peppol-endpoints-editor", {
                                    attrs: {
                                      "fallback-vat":
                                        _vm.contact.Vat ||
                                        _vm.contact.CommercialVat ||
                                        "",
                                    },
                                    on: { blur: _vm.checkPeppol },
                                    model: {
                                      value: _vm.contact.PeppolEndpoints,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.contact,
                                          "PeppolEndpoints",
                                          $$v
                                        )
                                      },
                                      expression: "contact.PeppolEndpoints",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "w-row",
                    [
                      _c("w-col", [
                        _c(
                          "div",
                          { style: { display: "flex", flexDirection: "row" } },
                          [
                            _vm.isAllowedMultiValuta
                              ? _c("app-currency-select", {
                                  staticClass: "mrs",
                                  style: { flexGrow: 0, flexShrink: 0 },
                                  attrs: { fancy: "" },
                                  model: {
                                    value: _vm.contact.CurrencyID,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.contact, "CurrencyID", $$v)
                                    },
                                    expression: "contact.CurrencyID",
                                  },
                                })
                              : _vm._e(),
                            _vm.contact.GroupID == 2
                              ? _c("app-purchase-vat-regime-select", {
                                  style: { flexGrow: 1 },
                                  attrs: {
                                    label: _vm.$ct("labels.VatRegime"),
                                    fancy: "",
                                  },
                                  model: {
                                    value: _vm.contact.VatRegime,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.contact, "VatRegime", $$v)
                                    },
                                    expression: "contact.VatRegime",
                                  },
                                })
                              : _c("app-sale-vat-regime-select", {
                                  style: { flexGrow: 1 },
                                  attrs: {
                                    label: _vm.$ct("labels.VatRegime"),
                                    fancy: "",
                                  },
                                  model: {
                                    value: _vm.contact.VatRegime,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.contact, "VatRegime", $$v)
                                    },
                                    expression: "contact.VatRegime",
                                  },
                                }),
                            _vm.contact.VatRegime == 1 &&
                            _vm.config.ContactSelectVatID
                              ? _c("app-vat-select", {
                                  ref: "vatItems",
                                  staticClass: "mls",
                                  style: { minWidth: "90px" },
                                  attrs: {
                                    "include-null": "",
                                    label: _vm.$ct("labels.VatPercentage"),
                                    fancy: "",
                                    "use-id": "",
                                  },
                                  model: {
                                    value: _vm.contact.DefaultVatID,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.contact, "DefaultVatID", $$v)
                                    },
                                    expression: "contact.DefaultVatID",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "w-transition-slide-height",
                    [
                      _vm.showVatRegimeWarning
                        ? _c(
                            "w-row",
                            [
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c(
                                    "app-error-message-box",
                                    { attrs: { "is-warning": "" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$ct(
                                              "vat-regime-is-probably-wrong-for-this-vat-number"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "w-transition-slide-height",
                    [
                      !_vm.contact.isVatValidForVatRegime()
                        ? _c(
                            "w-row",
                            [
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("app-error-message-box", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$ct(
                                            "vat-is-required-for-this-regime"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.contact.GroupID == 2
                    ? _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            [
                              _c("w-input", {
                                attrs: {
                                  label: _vm.$ct("labels.iban"),
                                  fancy: "",
                                },
                                on: {
                                  blur: function ($event) {
                                    return _vm.contact.autoFillBic()
                                  },
                                },
                                model: {
                                  value: _vm.contact.Iban,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.contact, "Iban", $$v)
                                  },
                                  expression: "contact.Iban",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.contact.GroupID == 2
                    ? _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            [
                              _c("w-input", {
                                attrs: {
                                  label: _vm.$ct("labels.bic"),
                                  fancy: "",
                                },
                                model: {
                                  value: _vm.contact.Bic,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.contact, "Bic", $$v)
                                  },
                                  expression: "contact.Bic",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("w-input-number", {
                            attrs: {
                              label: _vm.$ct("labels.payment_days"),
                              decimals: 0,
                              fancy: "",
                            },
                            model: {
                              value: _vm.contact.PaymentDays,
                              callback: function ($$v) {
                                _vm.$set(_vm.contact, "PaymentDays", $$v)
                              },
                              expression: "contact.PaymentDays",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        [
                          _c("w-checkbox", {
                            attrs: { label: _vm.$ct("labels.payment_month") },
                            model: {
                              value: _vm.contact.PaymentEndMonth,
                              callback: function ($$v) {
                                _vm.$set(_vm.contact, "PaymentEndMonth", $$v)
                              },
                              expression: "contact.PaymentEndMonth",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _vm.contact.GroupID == 1 || _vm.contact.GroupID == 3
                        ? _c(
                            "w-col",
                            [
                              _c("app-sell-category-select", {
                                attrs: {
                                  label: _vm.$ct("labels.SellPriceCategory"),
                                  "active-only": "",
                                  fancy: "",
                                },
                                model: {
                                  value: _vm.contact.SellPriceCategory,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.contact,
                                      "SellPriceCategory",
                                      $$v
                                    )
                                  },
                                  expression: "contact.SellPriceCategory",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("app-select-journal", {
                            attrs: {
                              label: _vm.$ct("labels.default-journal"),
                              fancy: "",
                            },
                            model: {
                              value: _vm.contact.DefaultJournalID,
                              callback: function ($$v) {
                                _vm.$set(_vm.contact, "DefaultJournalID", $$v)
                              },
                              expression: "contact.DefaultJournalID",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("w-input", {
                            attrs: { label: _vm.contactNrLabel, fancy: "" },
                            model: {
                              value: _vm.contact.ComputedFriendlyID,
                              callback: function ($$v) {
                                _vm.$set(_vm.contact, "ComputedFriendlyID", $$v)
                              },
                              expression: "contact.ComputedFriendlyID",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.showPeppolEndpointEdit
                    ? _c("w-row", [_c("w-col")], 1)
                    : _vm._e(),
                  _vm.hasModule(31)
                    ? _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            [
                              _c("app-default-creator-select", {
                                attrs: { contact: _vm.contact },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.hasMollieModuleConfigured
                    ? _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            [
                              _c("w-input", {
                                attrs: {
                                  fancy: "",
                                  label: _vm.$ct("mollie-customer-id"),
                                },
                                on: {
                                  blur: function ($event) {
                                    return _vm.checkIfMollieCustomerIsValid()
                                  },
                                },
                                model: {
                                  value: _vm.contact.MollieCustomerID,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.contact,
                                      "MollieCustomerID",
                                      $$v
                                    )
                                  },
                                  expression: "contact.MollieCustomerID",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.contact.GroupID == 2
                    ? _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            [
                              _c("app-ledger-account-autocomplete", {
                                attrs: {
                                  "add-remove-button": "",
                                  fancy: "",
                                  label: _vm.$ct("default-ledger-account"),
                                },
                                model: {
                                  value: _vm.contact.DefaultLedgerAccountCode,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.contact,
                                      "DefaultLedgerAccountCode",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "contact.DefaultLedgerAccountCode",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("app-ledger-account-autocomplete", {
                            attrs: {
                              "add-remove-button": "",
                              fancy: "",
                              "account-type": _vm.centralisationAccountType,
                              label: _vm.$ct("centralisation-ledger-account"),
                            },
                            model: {
                              value:
                                _vm.contact.CentralisationLedgerAccountCode,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.contact,
                                  "CentralisationLedgerAccountCode",
                                  $$v
                                )
                              },
                              expression:
                                "contact.CentralisationLedgerAccountCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.showLoyaltyBarcode
                    ? _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            [
                              _c("w-input", {
                                attrs: {
                                  label: _vm.$ct("labels.loyalty-barcode"),
                                  icon: _vm.generatingBarcode
                                    ? "spinner"
                                    : "magic",
                                  "icon-tooltip": _vm.$ct(
                                    "labels.generate-loyalty-barcode"
                                  ),
                                  fancy: "",
                                },
                                on: {
                                  "icon-click": function ($event) {
                                    return _vm.generateBarcode()
                                  },
                                },
                                model: {
                                  value: _vm.contact.Barcode,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.contact, "Barcode", $$v)
                                  },
                                  expression: "contact.Barcode",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.config.ShowBankOnContact
                    ? _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            [
                              _c("app-select-bank-type", {
                                attrs: {
                                  label: _vm.$ct("labels.default-bank"),
                                  fancy: "",
                                  "use-ids": "",
                                  "include-empty": "",
                                },
                                model: {
                                  value: _vm.contact.DefaultBankID,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.contact, "DefaultBankID", $$v)
                                  },
                                  expression: "contact.DefaultBankID",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "6" } },
                        [
                          _c("w-checkbox", {
                            attrs: { label: _vm.$ct("labels.active") },
                            model: {
                              value: _vm.contact.Active,
                              callback: function ($$v) {
                                _vm.$set(_vm.contact, "Active", $$v)
                              },
                              expression: "contact.Active",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "6" } },
                        [
                          _c("w-checkbox", {
                            attrs: { label: _vm.$ct("labels.blocked") },
                            model: {
                              value: _vm.contact.Blocked,
                              callback: function ($$v) {
                                _vm.$set(_vm.contact, "Blocked", $$v)
                              },
                              expression: "contact.Blocked",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-modal",
                {
                  attrs: { "escape-close": "" },
                  model: {
                    value: _vm.autofillModal,
                    callback: function ($$v) {
                      _vm.autofillModal = $$v
                    },
                    expression: "autofillModal",
                  },
                },
                [
                  _c("app-autofill-modal", {
                    attrs: {
                      contact: _vm.contact,
                      "autofill-data": _vm.autofillData,
                    },
                    on: {
                      close: function ($event) {
                        _vm.autofillModal = false
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card",
            { staticClass: "mt" },
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("titles.discount")))]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-input-number", {
                            attrs: {
                              label: _vm.$ct("labels.discount"),
                              fancy: "",
                            },
                            model: {
                              value: _vm.contact.Discount,
                              callback: function ($$v) {
                                _vm.$set(_vm.contact, "Discount", $$v)
                              },
                              expression: "contact.Discount",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { md: "6", xs: "12" } },
                        [
                          _c("w-input-number", {
                            attrs: {
                              label: _vm.$ct("labels.discountCash"),
                              fancy: "",
                            },
                            model: {
                              value: _vm.contact.DiscountCash,
                              callback: function ($$v) {
                                _vm.$set(_vm.contact, "DiscountCash", $$v)
                              },
                              expression: "contact.DiscountCash",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { md: "6", xs: "12" } },
                        [
                          _c("w-input-number", {
                            attrs: {
                              label: _vm.$ct("labels.discountCashDays"),
                              decimals: 0,
                              min: 0,
                              fancy: "",
                            },
                            model: {
                              value: _vm.contact.DiscountCashDays,
                              callback: function ($$v) {
                                _vm.$set(_vm.contact, "DiscountCashDays", $$v)
                              },
                              expression: "contact.DiscountCashDays",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card",
            { staticClass: "mt" },
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("titles.reminders")))]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-select", {
                            attrs: {
                              items: _vm.reminders,
                              label: _vm.$ct("labels.maxReminder"),
                              up: "",
                              fancy: "",
                            },
                            model: {
                              value: _vm.contact.MaxReminder,
                              callback: function ($$v) {
                                _vm.$set(_vm.contact, "MaxReminder", $$v)
                              },
                              expression: "contact.MaxReminder",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }